// TODO look over
import { toast, type ToastType, type ToastOptions as ToastifyOptions } from 'vue3-toastify'
import EmptyToast from '@/components/library/EmptyToast.vue'
import ActionToast from '@/components/library/ActionToast.vue'
import { h } from 'vue'
import UndoToast from '@/components/library/UndoToast.vue'

interface ToastOptions {
  showCloseButton?: boolean
  icon?: string
  iconClass?: string
}

interface ActionToastOptions {
  title: string
  message?: string
  buttonText: string
  buttonAction?: () => void
  buttonVariant?: 'primary' | 'secondary' | 'tertiary'
  showCloseButton?: boolean
  icon?: string
  iconClass?: string
  beforeCtaIcon?: string
  afterCtaIcon?: string
  showActionButton?: boolean
}

export const useToasts = () => {
  const showToast = (type: ToastType, text: string, options?: ToastOptions) => {
    toast(
      h(EmptyToast, {
        text,
        showCloseButton: options?.showCloseButton,
        icon: options?.icon,
        iconClass: options?.iconClass
      }),
      { type }
    )
  }

  const showInfoToast = (text: string, options?: ToastOptions) => {
    toast.info(
      h(EmptyToast, {
        text,
        showCloseButton: options?.showCloseButton,
        icon: options?.icon,
        iconClass: options?.iconClass
      })
    )
  }

  const showErrorToast = (text: string, options?: ToastOptions) => {
    toast.error(
      h(EmptyToast, {
        text,
        showCloseButton: options?.showCloseButton,
        icon: options?.icon,
        iconClass: options?.iconClass
      })
    )
  }

  const showWarningToast = (text: string, options?: ToastOptions) => {
    toast.warning(
      h(EmptyToast, {
        text,
        showCloseButton: options?.showCloseButton,
        icon: options?.icon,
        iconClass: options?.iconClass
      })
    )
  }

  const showExpressToast = (text: string, showCloseButton?: boolean) => {
    showInfoToast(text, { showCloseButton, icon: 'fa-regular fa-circle-bolt' })
  }

  const showActionToast = (type: ToastType, options: ActionToastOptions) => {
    toast(
      h(ActionToast, {
        title: options.title,
        message: options.message,
        buttonText: options.buttonText,
        buttonAction: options.buttonAction,
        buttonVariant: options.buttonVariant,
        showCloseButton: options.showCloseButton,
        icon: options.icon,
        iconClass: options.iconClass,
        beforeCtaIcon: options.beforeCtaIcon,
        afterCtaIcon: options.afterCtaIcon,
        showActionButton: options.showActionButton
      }),
      { type }
    )
  }

  const showUndoToast = (
    text: string,
    toastifyOptions?: ToastifyOptions,
    undoCallback?: () => void
  ) => {
    const id = toast.info(
      h(UndoToast, {
        text,
        undoCallback: () => {
          undoCallback?.()

          toast.remove(id)
        }
      }),
      toastifyOptions
    )
  }

  return {
    showToast,
    showInfoToast,
    showErrorToast,
    showWarningToast,
    showExpressToast,
    showActionToast,
    showUndoToast
  }
}
